import * as Types from '../../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type InfoBoxQueryVariables = Types.Exact<{ [key: string]: never }>;

export type InfoBoxQuery = {
  promotionPage: {
    __typename: 'PromotionPage';
    infobox:
      | {
          __typename: 'CommercialInfoboxModal';
          title: string | null;
          text: string | null;
          showFooter: boolean | null;
          id: string;
          image: { __typename: 'PrismicImage'; url: string | null } | null;
          link: {
            __typename: 'WebLink';
            text: string | null;
            url: string | null;
            tracking: {
              __typename: 'TrackingEvent';
              identifier: string | null;
              detail: Types.Scalars['JSON']['output'] | null;
            } | null;
          } | null;
          button: {
            __typename: 'Button';
            text: string | null;
            url: string | null;
            color: string | null;
            tracking: {
              __typename: 'TrackingEvent';
              identifier: string | null;
              detail: Types.Scalars['JSON']['output'] | null;
            } | null;
          } | null;
        }
      | { __typename: 'TermsAndPermissionInfobox'; id: string }
      | null;
  } | null;
};

export const InfoBoxDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InfoBox' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'promotionPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'path' },
                value: { kind: 'StringValue', value: '/', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'infobox' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CommercialInfoboxModal' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'link' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tracking' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'identifier' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'button' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tracking' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'identifier' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'showFooter' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InfoBoxQuery, InfoBoxQueryVariables>;
